import React, { useEffect, useState } from 'react';
import { getIcons } from '_helpers';
import { BatteryIndicatorHorizontal, BatteryIndicatorVertical }  from '_components/battery';
import { useNavigate } from 'react-router-dom';

export { BusDetailsCard };
 
function BusDetailsCard({ warnings }) {

    const [color, setColor] = useState('blue');
    const navigate = useNavigate();
    const [data, setData] = useState();
    const [lastSoc, setLastSoc] = useState(0);

    useEffect(() => {
        if(warnings?.info && warnings?.info.length > 0){
            setData(warnings.info[0])
        }
        if(warnings?.batterie){
            const soc = warnings.batterie.reduce((lastSOC, item) => {
                // Si le SOC de l'élément est non nul et non vide, on met à jour le lastSOC
                return (item.SOC !== null && item.SOC !== '') ? item.SOC : lastSOC;
            }, null);
            setLastSoc(soc);
        }
        // Fonction de nettoyage pour vider les données quand le composant est démonté
        return () => {
            setData([]);
        };
    }, [warnings])

    useEffect(() => {
        if (data?.URGENCY_LEVEL){
            switch (data.URGENCY_LEVEL) {
                case ("3"):
                    setColor('orange');
                    break;
                case ("4"):
                    setColor('red');
                    break;
                default:
                    setColor('blue');
                    break;;
            }
        }
    }, [data])

    const handleViewFleet = () => {
        navigate(`/donnees/flotte/${data.METROPOLIS}`)
    }

    if (!data) {
        return null; 
    }     

    const kms = data.RANGE ?? 'N/A',
        flotte = data.METROPOLIS ?? 'N/A',
        tensionBatterie = data.TBV ?? 'N/A',
        courantBatterie = data.TBC ?? 'N/A',
        socActuel = lastSoc ?? 'N/A',
        nombreBatteries = data.PCKS ?? 'N/A',
        country = data.COUNTRY ?? 'N/A',
        parcNumber = data.PARK_NUMBER ?? 'N/A',
        wsd = data.WSD ?? 'N/A',
        urgencyLevel = data['MAX(URGENCY_LEVEL)'] ?? 'N/A',
        state = data.STATE === 'EN ATTENTE' ? 'EN EXPLOITATION' : (data.STATE ?? 'N/A');
         

    return (
        <>
        {data && <div className={`flex side-panel-card ${color} `}>
            <div className="flex flex-col gap-4 px-4 pb-2 w-full">
                {/* Première ligne : 2 lignes sur la hauteur */}
                <div className="flex flex-col gap-2 w-full ">
                    <div className="flex-1 text-4xl text-center">Informations</div>
                    <div className="flex-1 ">VIN : <strong>{data.VIN}</strong></div>
                    <div className="flex-1 ">PARC : <strong>{parcNumber}</strong></div>
                </div>                
                {/* Deuxième ligne : divisée en 3 sur la largeur */}
                <div className="flex gap-4 h-24 w-full">
                    <div className="flex-1 ">
                        <div className="icon-group details-section">
                            <div className="icon"><img className='h-full mr-1' src={getIcons('mapOutlinedWhite')} alt='bus icon'/></div>
                            <div className="label">Pays</div>
                            <div className="value">{country}</div>
                        </div>
                    </div>
                    <div className="flex-1 cursor-pointer" onClick={handleViewFleet}>
                        <div className="icon-group details-section">
                            <div className="icon"><img className='h-full mr-1' src={getIcons('warehouseOutlinedWhite')} alt='bus icon'/></div>
                            <div className="label">Flotte</div>
                            <div className="value">{flotte}</div>
                        </div>
                    </div>
                    {/*parcNumber !=='N/A' && 
                    <div className="flex-1 ">
                        <div className="icon-group details-section">
                            <div className="icon"><img className='h-full mr-1' src={getIcons('warehouseOutlinedWhite')} alt='bus icon'/></div>
                            <div className="label">Parc</div>
                            <div className="value">{parcNumber}</div>
                        </div>
                    </div>*/}
                    <div className="flex-1 ">
                        {wsd !== 'N/A' && 
                        <div className="icon-group details-section">
                            <div className="icon"><img className='h-full mr-1' src={getIcons('constructionOutlined')} alt='bus icon'/></div>
                            <div className="label">WDS</div>
                            <div className="value">{wsd}</div>
                        </div>}
                    </div>
                </div>

                {/* Troisième ligne : 2 lignes sur la hauteur */}
                <div className="flex flex-col gap-4 flex-1">
                    <div className="flex gap-4 w-full">
                        <div className='h-full mr-1'>
                            <img className='h-full' src={getIcons('busAlertOutlinedWhite')} alt='bus icon'/>
                        </div>
                        <div className="">
                            <div className='flex'>
                                <div className='label'>Niveau: </div>
                                <div className='value ml-2'>{urgencyLevel === '4' ? ' Stop 4' :  (urgencyLevel === '3' ? ' Alerte 3' : ` Niveau ${urgencyLevel}`)}</div>
                            </div>
                            <div className='flex'>
                                <div className='label'>État: </div>
                                <div className='value ml-2'>{state}</div>
                            </div>                            
                        </div>
                    </div>
                    
                    {kms !== 'N/A' && 
                    <div className="flex gap-4 w-full">
                        <div className="big-number">{kms}</div>
                        <div className="text-xs flex flex-col justify-center">
                            <div>km d'autonomie</div>
                            {/*<div>kms parcourus<br/> au dernier<br/> événement</div>*/}
                        </div>
                    </div>}
                </div>

                {/* Quatrième ligne : divisée en deux sur la largeur */}
                <div className="flex gap-4 w-full">
                    {/* Partie gauche divisée en deux sur la hauteur */}
                    <div className="flex flex-col gap-4 w-1/3">
                        {tensionBatterie !== 'N/A' && 
                        <div className="flex-1 ">
                            <div className="big-number">{tensionBatterie} V</div>
                            <div className="text-xs">Tension batterie</div>
                        </div>}
                        {courantBatterie !== 'N/A' && 
                        <div className="flex-1 ">
                            <div className="big-number">{courantBatterie} A</div>
                            <div className="text-xs">Courant batterie</div>
                        </div>}
                    </div>
                    {/* Partie droite */}
                    <div className="w-2/3 ">
                        {socActuel !== 'N/A' && 
                        <div className="battery-soc w-[full]">
                            <div className="label details-section mb-2">SOC</div>
                            <BatteryIndicatorHorizontal percentage={socActuel} />
                        </div>}
                        {nombreBatteries !== 'N/A' && socActuel !== 'N/A' &&
                        <div className="battery-count mt-2">
                            {[...Array(nombreBatteries)].map((_, index) => (
                                < BatteryIndicatorVertical percentage={socActuel} key={index} index={index}/>
                            ))}
                        </div>}
                    </div>
                </div>
            </div>
        </div>}
        </>
    );
};
